import { Table } from 'antd'
import { useEffect, useState } from 'react'

import styles from './pure-table.module.scss'
import { TableProps } from './table-props'
import { SearchBlock } from '../search-block/search-block'

type SearchProps = {
  searchEnabled?: boolean
  searchPlaceholder?: string
  searchFields?: string[]
}

export const PureTable = ({
  columns,
  dataSource,
  rowKey,
  searchEnabled,
  searchPlaceholder,
  searchFields = ['name'],
  ...tableProps
}: TableProps & SearchProps) => {
  const [filteredDataSource, setFilteredDataSource] = useState<any>(dataSource)

  useEffect(() => {
    setFilteredDataSource(dataSource)
  }, [dataSource])

  const handleSearch = (search: string) => {
    if (!search) {
      setFilteredDataSource(dataSource)

      return
    }
    const filteredSource = dataSource?.filter((item: any) => {
      for (const i of searchFields) {
        if (item[i].includes(search)) {
          return true
        }
      }
    })

    setFilteredDataSource(filteredSource)
  }

  return (
    <>
      {searchEnabled ? (
        <SearchBlock
          onSearch={handleSearch}
          placeholder={searchPlaceholder ?? ''}
        />
      ) : null}
      <div className={styles.tableWrapper}>
        <Table
          {...tableProps}
          columns={columns}
          dataSource={filteredDataSource}
          pagination={false}
          rowHoverable={false}
          rowKey={(rowKey as any) ?? 'id'}
        />
      </div>
    </>
  )
}
